import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { usePepwiseAuthController } from 'Context/contexts/AuthContext';
import { checkRole } from 'utils/roleUtils';
import FinOpsExecutiveDashboard from 'components/FinOpsExecutive/FinOpsExecutiveDashboard';
import DataEstateCostSummary from 'components/DataEstate/cost-summary';
import ResourceCostSummary from 'components/FineOps/ResourceMapping/ResourceCostSummary';
import FinOpsMetrics from 'components/FineOps/FinOpsMetrics';
import { FINOPS_EXEC_COST_ROLES, FINOPS_USER_ROLES } from './finopsRoles';

const EXEC_COST_TAB_MAP: Record<number, number> = { 3: 0, 4: 1, 5: 2, 6: 3 };

const FinOpsTabsInner: React.FC = () => {
	const [searchParams] = useSearchParams();
	const navigate = useNavigate();
	const [controller] = usePepwiseAuthController();
	const { role } = controller;

	const hasExecCost = checkRole(role, FINOPS_EXEC_COST_ROLES);
	const hasFinOps = checkRole(role, FINOPS_USER_ROLES);

	const tab = parseInt(searchParams.get('tab') ?? '0', 10);
	const execCostInitialTab = EXEC_COST_TAB_MAP[tab];

	const isFinOpsTab = tab <= 2;
	const isExecCostTab = execCostInitialTab !== undefined;

	useEffect(() => {
		if (!hasFinOps && isFinOpsTab && hasExecCost) {
			navigate('/finops/executive?tab=3', { replace: true });
		} else if (!hasExecCost && isExecCostTab && hasFinOps) {
			navigate('/finops/executive', { replace: true });
		}
	}, [hasExecCost, hasFinOps, tab]);

	return (
		<Box
			className="finops-tabs-container"
			sx={{
				backgroundColor: 'backgroundLight.primary',
				minHeight: '100vh',
				pt: '56px',
			}}
		>
			{hasFinOps && tab === 0 && <FinOpsExecutiveDashboard />}
			{hasFinOps && tab === 1 && <DataEstateCostSummary />}
			{hasFinOps && tab === 2 && <FinOpsMetrics />}
			{hasExecCost && execCostInitialTab !== undefined && <ResourceCostSummary initialTab={execCostInitialTab} />}
		</Box>
	);
};

const FinOpsTabs: React.FC = () => (
	// FinOpsTabProvider is now at App level via FinOpsShell
	<FinOpsTabsInner />
);

export default FinOpsTabs;
